import { isValid, parseISO } from 'date-fns'
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz'

const ISO_TIME_ZONE_SUFFIX = /([zZ]|[+-]\d{2}:?\d{2})$/
const ISO_8601_UTC_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'"

/**
 * Converts an ISO date string to UTC in ISO 8601 format.
 * Date strings without an offset are interpreted as UTC.
 * @param date An ISO date string, for example, 2018-09-19T19:52:12
 * @returns A UTC date string in ISO 8601 format, for example, 2018-09-19T19:52:12Z
 */
export const convertUTCToISO8601format = (date: string) => {
  if (!date) {
    return ''
  }

  const parsedDate = ISO_TIME_ZONE_SUFFIX.test(date) ? parseISO(date) : zonedTimeToUtc(date, 'UTC')
  return isValid(parsedDate) ? formatInTimeZone(parsedDate, 'UTC', ISO_8601_UTC_FORMAT) : 'Invalid date'
}
